// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type {
  FormFile,
  ZonedDateTime,
  Language,
  Tag,
  TagSourceType,
  TagKindDynamicString,
  KindDynamicString,
  TagKindDynamicBoolean,
  KindDynamicBoolean,
  TagKindDynamicNumber,
  KindDynamicNumber,
  TagKindDynamicVoid,
  KindDynamicVoid,
  TagKindChannel,
  KindChannel,
  TagKindPrimarySkill,
  KindPrimarySkill,
  TagKindSkill,
  KindSkill,
  TagKindKeyQuality,
  KindKeyQuality,
  TagKindClassification,
  KindClassification,
  ExpertVideoAdminForm,
} from "../schema";

export function serialize_ExpertVideoAdminForm(obj: ExpertVideoAdminForm): string {
  const serialized = ((value: {
    aboutTheHost: string;
    active: boolean;
    authorIds: bigint[];
    authorImage: FormFile | null;
    eventDateTime: ZonedDateTime;
    expertVideoId: bigint;
    language: Language;
    length: number;
    pdf: FormFile | null;
    registrationLink: string;
    tableOfContent: {
      timestamp: number;
      title: string;
    }[];
    tags: Tag[];
    teaser: string;
    title: string;
    transcript: string;
    vimeoLink: string;
    whatYouLearn: string;
    youtubeLink: string;
  }): unknown => {
    return {
      aboutTheHost: ((value: string): unknown => {
        return value;
      })(value["aboutTheHost"]),
      active: ((value: boolean): unknown => {
        return value;
      })(value["active"]),
      authorIds: ((value: bigint[]): unknown => {
        return value.map((value: bigint): unknown => {
          return value;
        });
      })(value["authorIds"]),
      authorImage: ((
        value: {
          bytes: ReadonlyUint8Array;
          filename: string;
          mimeType: string;
        } | null,
      ): unknown => {
        if (value === null) {
          return null;
        }
        return {
          bytes: ((value: ReadonlyUint8Array): unknown => {
            return toBase64(value);
          })(value["bytes"]),
          filename: ((value: string): unknown => {
            return value;
          })(value["filename"]),
          mimeType: ((value: string): unknown => {
            return value;
          })(value["mimeType"]),
        };
      })(value["authorImage"]),
      eventDateTime: ((value: { datetime: string; timezone: string }): unknown => {
        return {
          datetime: ((value: string): unknown => {
            return value;
          })(value["datetime"]),
          timezone: ((value: string): unknown => {
            return value;
          })(value["timezone"]),
        };
      })(value["eventDateTime"]),
      expertVideoId: ((value: bigint): unknown => {
        return value;
      })(value["expertVideoId"]),
      language: ((value: "en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"): unknown => {
        return value;
      })(value["language"]),
      length: ((value: number): unknown => {
        return value;
      })(value["length"]),
      pdf: ((
        value: {
          bytes: ReadonlyUint8Array;
          filename: string;
          mimeType: string;
        } | null,
      ): unknown => {
        if (value === null) {
          return null;
        }
        return {
          bytes: ((value: ReadonlyUint8Array): unknown => {
            return toBase64(value);
          })(value["bytes"]),
          filename: ((value: string): unknown => {
            return value;
          })(value["filename"]),
          mimeType: ((value: string): unknown => {
            return value;
          })(value["mimeType"]),
        };
      })(value["pdf"]),
      registrationLink: ((value: string): unknown => {
        return value;
      })(value["registrationLink"]),
      tableOfContent: ((
        value: {
          timestamp: number;
          title: string;
        }[],
      ): unknown => {
        return value.map((value: { timestamp: number; title: string }): unknown => {
          return {
            timestamp: ((value: number): unknown => {
              return value;
            })(value["timestamp"]),
            title: ((value: string): unknown => {
              return value;
            })(value["title"]),
          };
        });
      })(value["tableOfContent"]),
      tags: ((value: Tag[]): unknown => {
        return value.map(
          (
            value:
              | { discriminator: "dynamicString"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicString; value: string }
              | { discriminator: "dynamicBoolean"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicBoolean; value: boolean }
              | { discriminator: "dynamicNumber"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicNumber; value: number }
              | { discriminator: "dynamicVoid"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicVoid }
              | { discriminator: "channel"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindChannel; value: string }
              | { discriminator: "primary-skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindPrimarySkill; value: string }
              | { discriminator: "skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindSkill; value: string }
              | { discriminator: "key-quality"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindKeyQuality; value: string }
              | { discriminator: "classification"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindClassification; value: string },
          ): unknown => {
            switch (value.discriminator) {
              case "dynamicString": {
                return {
                  discriminator: "dynamicString",
                  exclude: ((value: boolean): unknown => {
                    return value;
                  })(value["exclude"]),
                  score: ((value: number): unknown => {
                    return value;
                  })(value["score"]),
                  source: ((value: "USER" | "AI"): unknown => {
                    return value;
                  })(value["source"]),
                  tagKind: ((value: { discriminator: KindDynamicString; id: bigint; kind: string }): unknown => {
                    return {
                      discriminator: ((value: "dynamicString"): unknown => {
                        return value;
                      })(value["discriminator"]),
                      id: ((value: bigint): unknown => {
                        return value;
                      })(value["id"]),
                      kind: ((value: string): unknown => {
                        return value;
                      })(value["kind"]),
                    };
                  })(value["tagKind"]),
                  value: ((value: string): unknown => {
                    return value;
                  })(value["value"]),
                };
              }
              case "dynamicBoolean": {
                return {
                  discriminator: "dynamicBoolean",
                  exclude: ((value: boolean): unknown => {
                    return value;
                  })(value["exclude"]),
                  score: ((value: number): unknown => {
                    return value;
                  })(value["score"]),
                  source: ((value: "USER" | "AI"): unknown => {
                    return value;
                  })(value["source"]),
                  tagKind: ((value: { discriminator: KindDynamicBoolean; id: bigint; kind: string }): unknown => {
                    return {
                      discriminator: ((value: "dynamicBoolean"): unknown => {
                        return value;
                      })(value["discriminator"]),
                      id: ((value: bigint): unknown => {
                        return value;
                      })(value["id"]),
                      kind: ((value: string): unknown => {
                        return value;
                      })(value["kind"]),
                    };
                  })(value["tagKind"]),
                  value: ((value: boolean): unknown => {
                    return value;
                  })(value["value"]),
                };
              }
              case "dynamicNumber": {
                return {
                  discriminator: "dynamicNumber",
                  exclude: ((value: boolean): unknown => {
                    return value;
                  })(value["exclude"]),
                  score: ((value: number): unknown => {
                    return value;
                  })(value["score"]),
                  source: ((value: "USER" | "AI"): unknown => {
                    return value;
                  })(value["source"]),
                  tagKind: ((value: { discriminator: KindDynamicNumber; id: bigint; kind: string }): unknown => {
                    return {
                      discriminator: ((value: "dynamicNumber"): unknown => {
                        return value;
                      })(value["discriminator"]),
                      id: ((value: bigint): unknown => {
                        return value;
                      })(value["id"]),
                      kind: ((value: string): unknown => {
                        return value;
                      })(value["kind"]),
                    };
                  })(value["tagKind"]),
                  value: ((value: number): unknown => {
                    return value;
                  })(value["value"]),
                };
              }
              case "dynamicVoid": {
                return {
                  discriminator: "dynamicVoid",
                  exclude: ((value: boolean): unknown => {
                    return value;
                  })(value["exclude"]),
                  score: ((value: number): unknown => {
                    return value;
                  })(value["score"]),
                  source: ((value: "USER" | "AI"): unknown => {
                    return value;
                  })(value["source"]),
                  tagKind: ((value: { discriminator: KindDynamicVoid; id: bigint; kind: string }): unknown => {
                    return {
                      discriminator: ((value: "dynamicVoid"): unknown => {
                        return value;
                      })(value["discriminator"]),
                      id: ((value: bigint): unknown => {
                        return value;
                      })(value["id"]),
                      kind: ((value: string): unknown => {
                        return value;
                      })(value["kind"]),
                    };
                  })(value["tagKind"]),
                };
              }
              case "channel": {
                return {
                  discriminator: "channel",
                  exclude: ((value: boolean): unknown => {
                    return value;
                  })(value["exclude"]),
                  score: ((value: number): unknown => {
                    return value;
                  })(value["score"]),
                  source: ((value: "USER" | "AI"): unknown => {
                    return value;
                  })(value["source"]),
                  tagKind: ((value: { discriminator: KindChannel; id: bigint; kind: KindChannel }): unknown => {
                    return {
                      discriminator: ((value: "channel"): unknown => {
                        return value;
                      })(value["discriminator"]),
                      id: ((value: bigint): unknown => {
                        return value;
                      })(value["id"]),
                      kind: ((value: "channel"): unknown => {
                        return value;
                      })(value["kind"]),
                    };
                  })(value["tagKind"]),
                  value: ((value: string): unknown => {
                    return value;
                  })(value["value"]),
                };
              }
              case "primary-skill": {
                return {
                  discriminator: "primary-skill",
                  exclude: ((value: boolean): unknown => {
                    return value;
                  })(value["exclude"]),
                  score: ((value: number): unknown => {
                    return value;
                  })(value["score"]),
                  source: ((value: "USER" | "AI"): unknown => {
                    return value;
                  })(value["source"]),
                  tagKind: ((value: { discriminator: KindPrimarySkill; id: bigint; kind: KindPrimarySkill }): unknown => {
                    return {
                      discriminator: ((value: "primary-skill"): unknown => {
                        return value;
                      })(value["discriminator"]),
                      id: ((value: bigint): unknown => {
                        return value;
                      })(value["id"]),
                      kind: ((value: "primary-skill"): unknown => {
                        return value;
                      })(value["kind"]),
                    };
                  })(value["tagKind"]),
                  value: ((value: string): unknown => {
                    return value;
                  })(value["value"]),
                };
              }
              case "skill": {
                return {
                  discriminator: "skill",
                  exclude: ((value: boolean): unknown => {
                    return value;
                  })(value["exclude"]),
                  score: ((value: number): unknown => {
                    return value;
                  })(value["score"]),
                  source: ((value: "USER" | "AI"): unknown => {
                    return value;
                  })(value["source"]),
                  tagKind: ((value: { discriminator: KindSkill; id: bigint; kind: KindSkill }): unknown => {
                    return {
                      discriminator: ((value: "skill"): unknown => {
                        return value;
                      })(value["discriminator"]),
                      id: ((value: bigint): unknown => {
                        return value;
                      })(value["id"]),
                      kind: ((value: "skill"): unknown => {
                        return value;
                      })(value["kind"]),
                    };
                  })(value["tagKind"]),
                  value: ((value: string): unknown => {
                    return value;
                  })(value["value"]),
                };
              }
              case "key-quality": {
                return {
                  discriminator: "key-quality",
                  exclude: ((value: boolean): unknown => {
                    return value;
                  })(value["exclude"]),
                  score: ((value: number): unknown => {
                    return value;
                  })(value["score"]),
                  source: ((value: "USER" | "AI"): unknown => {
                    return value;
                  })(value["source"]),
                  tagKind: ((value: { discriminator: KindKeyQuality; id: bigint; kind: KindKeyQuality }): unknown => {
                    return {
                      discriminator: ((value: "key-quality"): unknown => {
                        return value;
                      })(value["discriminator"]),
                      id: ((value: bigint): unknown => {
                        return value;
                      })(value["id"]),
                      kind: ((value: "key-quality"): unknown => {
                        return value;
                      })(value["kind"]),
                    };
                  })(value["tagKind"]),
                  value: ((value: string): unknown => {
                    return value;
                  })(value["value"]),
                };
              }
              case "classification": {
                return {
                  discriminator: "classification",
                  exclude: ((value: boolean): unknown => {
                    return value;
                  })(value["exclude"]),
                  score: ((value: number): unknown => {
                    return value;
                  })(value["score"]),
                  source: ((value: "USER" | "AI"): unknown => {
                    return value;
                  })(value["source"]),
                  tagKind: ((value: { discriminator: KindClassification; id: bigint; kind: KindClassification }): unknown => {
                    return {
                      discriminator: ((value: "classification"): unknown => {
                        return value;
                      })(value["discriminator"]),
                      id: ((value: bigint): unknown => {
                        return value;
                      })(value["id"]),
                      kind: ((value: "classification"): unknown => {
                        return value;
                      })(value["kind"]),
                    };
                  })(value["tagKind"]),
                  value: ((value: string): unknown => {
                    return value;
                  })(value["value"]),
                };
              }
            }
          },
        );
      })(value["tags"]),
      teaser: ((value: string): unknown => {
        return value;
      })(value["teaser"]),
      title: ((value: string): unknown => {
        return value;
      })(value["title"]),
      transcript: ((value: string): unknown => {
        return value;
      })(value["transcript"]),
      vimeoLink: ((value: string): unknown => {
        return value;
      })(value["vimeoLink"]),
      whatYouLearn: ((value: string): unknown => {
        return value;
      })(value["whatYouLearn"]),
      youtubeLink: ((value: string): unknown => {
        return value;
      })(value["youtubeLink"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_ExpertVideoAdminForm(str: string): ParserResult<ExpertVideoAdminForm> {
  return ((
    value: unknown,
  ): ParserResult<{
    aboutTheHost: string;
    active: boolean;
    authorIds: bigint[];
    authorImage: FormFile | null;
    eventDateTime: ZonedDateTime;
    expertVideoId: bigint;
    language: Language;
    length: number;
    pdf: FormFile | null;
    registrationLink: string;
    tableOfContent: {
      timestamp: number;
      title: string;
    }[];
    tags: Tag[];
    teaser: string;
    title: string;
    transcript: string;
    vimeoLink: string;
    whatYouLearn: string;
    youtubeLink: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "aboutTheHost")) {
      return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/aboutTheHost]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'aboutTheHost'.` };
    }
    const parsed_aboutTheHost = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/aboutTheHost]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["aboutTheHost"]);
    })();
    if (!parsed_aboutTheHost.success) {
      return { success: false, reason: parsed_aboutTheHost.reason };
    }
    if (!hasProp(value, "active")) {
      return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/active]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'active'.` };
    }
    const parsed_active = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/active]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["active"]);
    })();
    if (!parsed_active.success) {
      return { success: false, reason: parsed_active.reason };
    }
    if (!hasProp(value, "authorIds")) {
      return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/authorIds]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'authorIds'.` };
    }
    const parsed_authorIds = ((): ParserResult<bigint[]> => {
      return ((value: unknown): ParserResult<bigint[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/authorIds]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<bigint> => {
          if (typeof value === "number") {
            return { success: true, value: BigInt(value) };
          }
          if (typeof value === "bigint") {
            return { success: true, value: value };
          }
          return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/authorIds]: '${value}' expected to be of type bigint or number.` };
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/ExpertVideoAdminForm/authorIds]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["authorIds"]);
    })();
    if (!parsed_authorIds.success) {
      return { success: false, reason: parsed_authorIds.reason };
    }
    if (!hasProp(value, "authorImage")) {
      return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/authorImage]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'authorImage'.` };
    }
    const parsed_authorImage = ((): ParserResult<FormFile | null> => {
      return ((value: unknown): ParserResult<FormFile | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        return ((
          value: unknown,
        ): ParserResult<{
          bytes: ReadonlyUint8Array;
          filename: string;
          mimeType: string;
        }> => {
          if (typeof value !== "object") {
            return { success: false, reason: `[#/components/schemas/FormFile]: '${value}' expected to be of type 'object'.` };
          }
          if (value === null) {
            return { success: false, reason: `[#/components/schemas/FormFile]: '${value}' expected to not be null.` };
          }
          if (!hasProp(value, "bytes")) {
            return { success: false, reason: `[#/components/schemas/FormFile/bytes]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'bytes'.` };
          }
          const parsed_bytes = ((): ParserResult<ReadonlyUint8Array> => {
            return ((value: unknown): ParserResult<ReadonlyUint8Array> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/FormFile/bytes]: '${value}' expected to be of type string.` };
              }
              const binary = (() => {
                try {
                  const binaryString = atob(value);
                  const arr = new Uint8Array(binaryString.length);
                  for (let i = 0; i < binaryString.length; i++) {
                    arr[i] = binaryString.charCodeAt(i);
                  }
                  return arr;
                } catch (ex) {
                  return null;
                }
              })();
              if (binary === null) {
                return { success: false, reason: `[#/components/schemas/FormFile/bytes]: '${value}' expected to be a valid base64 string.` };
              }
              return { success: true, value: binary };
            })(value["bytes"]);
          })();
          if (!parsed_bytes.success) {
            return { success: false, reason: parsed_bytes.reason };
          }
          if (!hasProp(value, "filename")) {
            return { success: false, reason: `[#/components/schemas/FormFile/filename]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'filename'.` };
          }
          const parsed_filename = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/FormFile/filename]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["filename"]);
          })();
          if (!parsed_filename.success) {
            return { success: false, reason: parsed_filename.reason };
          }
          if (!hasProp(value, "mimeType")) {
            return { success: false, reason: `[#/components/schemas/FormFile/mimeType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'mimeType'.` };
          }
          const parsed_mimeType = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/FormFile/mimeType]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["mimeType"]);
          })();
          if (!parsed_mimeType.success) {
            return { success: false, reason: parsed_mimeType.reason };
          }
          return { success: true, value: { bytes: parsed_bytes.value, filename: parsed_filename.value, mimeType: parsed_mimeType.value } };
        })(value);
      })(value["authorImage"]);
    })();
    if (!parsed_authorImage.success) {
      return { success: false, reason: parsed_authorImage.reason };
    }
    if (!hasProp(value, "eventDateTime")) {
      return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/eventDateTime]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'eventDateTime'.` };
    }
    const parsed_eventDateTime = ((): ParserResult<ZonedDateTime> => {
      return ((value: unknown): ParserResult<ZonedDateTime> => {
        return ((
          value: unknown,
        ): ParserResult<{
          datetime: string;
          timezone: string;
        }> => {
          if (typeof value !== "object") {
            return { success: false, reason: `[#/components/schemas/ZonedDateTime]: '${value}' expected to be of type 'object'.` };
          }
          if (value === null) {
            return { success: false, reason: `[#/components/schemas/ZonedDateTime]: '${value}' expected to not be null.` };
          }
          if (!hasProp(value, "datetime")) {
            return { success: false, reason: `[#/components/schemas/ZonedDateTime/datetime]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'datetime'.` };
          }
          const parsed_datetime = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/ZonedDateTime/datetime]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["datetime"]);
          })();
          if (!parsed_datetime.success) {
            return { success: false, reason: parsed_datetime.reason };
          }
          if (!hasProp(value, "timezone")) {
            return { success: false, reason: `[#/components/schemas/ZonedDateTime/timezone]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'timezone'.` };
          }
          const parsed_timezone = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/ZonedDateTime/timezone]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["timezone"]);
          })();
          if (!parsed_timezone.success) {
            return { success: false, reason: parsed_timezone.reason };
          }
          return { success: true, value: { datetime: parsed_datetime.value, timezone: parsed_timezone.value } };
        })(value);
      })(value["eventDateTime"]);
    })();
    if (!parsed_eventDateTime.success) {
      return { success: false, reason: parsed_eventDateTime.reason };
    }
    if (!hasProp(value, "expertVideoId")) {
      return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/expertVideoId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'expertVideoId'.` };
    }
    const parsed_expertVideoId = ((): ParserResult<bigint> => {
      return ((value: unknown): ParserResult<bigint> => {
        if (typeof value === "number") {
          return { success: true, value: BigInt(value) };
        }
        if (typeof value === "bigint") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/expertVideoId]: '${value}' expected to be of type bigint or number.` };
      })(value["expertVideoId"]);
    })();
    if (!parsed_expertVideoId.success) {
      return { success: false, reason: parsed_expertVideoId.reason };
    }
    if (!hasProp(value, "language")) {
      return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/language]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'language'.` };
    }
    const parsed_language = ((): ParserResult<Language> => {
      return ((value: unknown): ParserResult<Language> => {
        return ((value: unknown): ParserResult<"en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be of type string.` };
          }
          switch (value) {
            case "en":
              return { success: true, value: "en" };
            case "de":
              return { success: true, value: "de" };
            case "es":
              return { success: true, value: "es" };
            case "ru":
              return { success: true, value: "ru" };
            case "zh":
              return { success: true, value: "zh" };
            case "pt":
              return { success: true, value: "pt" };
            case "fr":
              return { success: true, value: "fr" };
            default:
              return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be enum, one of 'en, de, es, ru, zh, pt, fr'.` };
          }
        })(value);
      })(value["language"]);
    })();
    if (!parsed_language.success) {
      return { success: false, reason: parsed_language.reason };
    }
    if (!hasProp(value, "length")) {
      return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/length]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'length'.` };
    }
    const parsed_length = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/length]: '${value}' expected to be of type number.` };
      })(value["length"]);
    })();
    if (!parsed_length.success) {
      return { success: false, reason: parsed_length.reason };
    }
    if (!hasProp(value, "pdf")) {
      return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/pdf]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'pdf'.` };
    }
    const parsed_pdf = ((): ParserResult<FormFile | null> => {
      return ((value: unknown): ParserResult<FormFile | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        return ((
          value: unknown,
        ): ParserResult<{
          bytes: ReadonlyUint8Array;
          filename: string;
          mimeType: string;
        }> => {
          if (typeof value !== "object") {
            return { success: false, reason: `[#/components/schemas/FormFile]: '${value}' expected to be of type 'object'.` };
          }
          if (value === null) {
            return { success: false, reason: `[#/components/schemas/FormFile]: '${value}' expected to not be null.` };
          }
          if (!hasProp(value, "bytes")) {
            return { success: false, reason: `[#/components/schemas/FormFile/bytes]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'bytes'.` };
          }
          const parsed_bytes = ((): ParserResult<ReadonlyUint8Array> => {
            return ((value: unknown): ParserResult<ReadonlyUint8Array> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/FormFile/bytes]: '${value}' expected to be of type string.` };
              }
              const binary = (() => {
                try {
                  const binaryString = atob(value);
                  const arr = new Uint8Array(binaryString.length);
                  for (let i = 0; i < binaryString.length; i++) {
                    arr[i] = binaryString.charCodeAt(i);
                  }
                  return arr;
                } catch (ex) {
                  return null;
                }
              })();
              if (binary === null) {
                return { success: false, reason: `[#/components/schemas/FormFile/bytes]: '${value}' expected to be a valid base64 string.` };
              }
              return { success: true, value: binary };
            })(value["bytes"]);
          })();
          if (!parsed_bytes.success) {
            return { success: false, reason: parsed_bytes.reason };
          }
          if (!hasProp(value, "filename")) {
            return { success: false, reason: `[#/components/schemas/FormFile/filename]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'filename'.` };
          }
          const parsed_filename = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/FormFile/filename]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["filename"]);
          })();
          if (!parsed_filename.success) {
            return { success: false, reason: parsed_filename.reason };
          }
          if (!hasProp(value, "mimeType")) {
            return { success: false, reason: `[#/components/schemas/FormFile/mimeType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'mimeType'.` };
          }
          const parsed_mimeType = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/FormFile/mimeType]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["mimeType"]);
          })();
          if (!parsed_mimeType.success) {
            return { success: false, reason: parsed_mimeType.reason };
          }
          return { success: true, value: { bytes: parsed_bytes.value, filename: parsed_filename.value, mimeType: parsed_mimeType.value } };
        })(value);
      })(value["pdf"]);
    })();
    if (!parsed_pdf.success) {
      return { success: false, reason: parsed_pdf.reason };
    }
    if (!hasProp(value, "registrationLink")) {
      return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/registrationLink]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'registrationLink'.` };
    }
    const parsed_registrationLink = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/registrationLink]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["registrationLink"]);
    })();
    if (!parsed_registrationLink.success) {
      return { success: false, reason: parsed_registrationLink.reason };
    }
    if (!hasProp(value, "tableOfContent")) {
      return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/tableOfContent]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tableOfContent'.` };
    }
    const parsed_tableOfContent = ((): ParserResult<
      {
        timestamp: number;
        title: string;
      }[]
    > => {
      return ((
        value: unknown,
      ): ParserResult<
        {
          timestamp: number;
          title: string;
        }[]
      > => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/tableOfContent]: '${value}' expected to be an array.` };
        }
        const parsed = value.map(
          (
            value: unknown,
          ): ParserResult<{
            timestamp: number;
            title: string;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/tableOfContent/[null]]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/tableOfContent/[null]]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "timestamp")) {
              return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/tableOfContent/[null]/timestamp]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'timestamp'.` };
            }
            const parsed_timestamp = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/tableOfContent/[null]/timestamp]: '${value}' expected to be of type number.` };
              })(value["timestamp"]);
            })();
            if (!parsed_timestamp.success) {
              return { success: false, reason: parsed_timestamp.reason };
            }
            if (!hasProp(value, "title")) {
              return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/tableOfContent/[null]/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
            }
            const parsed_title = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/tableOfContent/[null]/title]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["title"]);
            })();
            if (!parsed_title.success) {
              return { success: false, reason: parsed_title.reason };
            }
            return { success: true, value: { timestamp: parsed_timestamp.value, title: parsed_title.value } };
          },
        );
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/ExpertVideoAdminForm/tableOfContent]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["tableOfContent"]);
    })();
    if (!parsed_tableOfContent.success) {
      return { success: false, reason: parsed_tableOfContent.reason };
    }
    if (!hasProp(value, "tags")) {
      return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/tags]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tags'.` };
    }
    const parsed_tags = ((): ParserResult<Tag[]> => {
      return ((value: unknown): ParserResult<Tag[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/tags]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<Tag> => {
          return ((
            value: unknown,
          ): ParserResult<
            | { discriminator: "dynamicString"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicString; value: string }
            | { discriminator: "dynamicBoolean"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicBoolean; value: boolean }
            | { discriminator: "dynamicNumber"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicNumber; value: number }
            | { discriminator: "dynamicVoid"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicVoid }
            | { discriminator: "channel"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindChannel; value: string }
            | { discriminator: "primary-skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindPrimarySkill; value: string }
            | { discriminator: "skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindSkill; value: string }
            | { discriminator: "key-quality"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindKeyQuality; value: string }
            | { discriminator: "classification"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindClassification; value: string }
          > => {
            return ((
              value: unknown,
            ): ParserResult<
              | { discriminator: "dynamicString"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicString; value: string }
              | { discriminator: "dynamicBoolean"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicBoolean; value: boolean }
              | { discriminator: "dynamicNumber"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicNumber; value: number }
              | { discriminator: "dynamicVoid"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicVoid }
              | { discriminator: "channel"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindChannel; value: string }
              | { discriminator: "primary-skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindPrimarySkill; value: string }
              | { discriminator: "skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindSkill; value: string }
              | { discriminator: "key-quality"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindKeyQuality; value: string }
              | { discriminator: "classification"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindClassification; value: string }
            > => {
              if (value == null) {
                return { success: false, reason: `[#/components/schemas/Tag]: '${value}' expected to be non-null.` };
              }
              if (typeof value != "object") {
                return { success: false, reason: `[#/components/schemas/Tag]: ${value} expected to be of type 'object'.` };
              }
              if (!hasProp(value, "discriminator")) {
                return { success: false, reason: `[#/components/schemas/Tag]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
              }
              if (typeof value["discriminator"] != "string") {
                return { success: false, reason: `[#/components/schemas/Tag]: '${value["discriminator"]}' expected to be of type 'string'.` };
              }
              const discriminator = value["discriminator"];
              switch (discriminator) {
                case "dynamicString": {
                  const parsedVariant = ((
                    value: unknown,
                  ): ParserResult<{
                    exclude: boolean;
                    score: number;
                    source: TagSourceType;
                    tagKind: TagKindDynamicString;
                    value: string;
                  }> => {
                    if (typeof value !== "object") {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicString]: '${value}' expected to be of type 'object'.` };
                    }
                    if (value === null) {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicString]: '${value}' expected to not be null.` };
                    }
                    if (!hasProp(value, "exclude")) {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicString/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                    }
                    const parsed_exclude = ((): ParserResult<boolean> => {
                      return ((value: unknown): ParserResult<boolean> => {
                        if (typeof value !== "boolean") {
                          return { success: false, reason: `[#/components/schemas/Tag/dynamicString/exclude]: '${value}' expected to be of type boolean.` };
                        }
                        return { success: true, value: value };
                      })(value["exclude"]);
                    })();
                    if (!parsed_exclude.success) {
                      return { success: false, reason: parsed_exclude.reason };
                    }
                    if (!hasProp(value, "score")) {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicString/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                    }
                    const parsed_score = ((): ParserResult<number> => {
                      return ((value: unknown): ParserResult<number> => {
                        if (typeof value === "number") {
                          return { success: true, value: value };
                        }
                        if (typeof value === "bigint") {
                          return { success: true, value: Number(value) };
                        }
                        return { success: false, reason: `[#/components/schemas/Tag/dynamicString/score]: '${value}' expected to be of type number or bigint.` };
                      })(value["score"]);
                    })();
                    if (!parsed_score.success) {
                      return { success: false, reason: parsed_score.reason };
                    }
                    if (!hasProp(value, "source")) {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicString/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                    }
                    const parsed_source = ((): ParserResult<TagSourceType> => {
                      return ((value: unknown): ParserResult<TagSourceType> => {
                        return ((value: unknown): ParserResult<"USER" | "AI"> => {
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                          }
                          switch (value) {
                            case "USER":
                              return { success: true, value: "USER" };
                            case "AI":
                              return { success: true, value: "AI" };
                            default:
                              return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                          }
                        })(value);
                      })(value["source"]);
                    })();
                    if (!parsed_source.success) {
                      return { success: false, reason: parsed_source.reason };
                    }
                    if (!hasProp(value, "tagKind")) {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicString/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                    }
                    const parsed_tagKind = ((): ParserResult<TagKindDynamicString> => {
                      return ((value: unknown): ParserResult<TagKindDynamicString> => {
                        return ((
                          value: unknown,
                        ): ParserResult<{
                          discriminator: KindDynamicString;
                          id: bigint;
                          kind: string;
                        }> => {
                          if (typeof value !== "object") {
                            return { success: false, reason: `[#/components/schemas/TagKindDynamicString]: '${value}' expected to be of type 'object'.` };
                          }
                          if (value === null) {
                            return { success: false, reason: `[#/components/schemas/TagKindDynamicString]: '${value}' expected to not be null.` };
                          }
                          if (!hasProp(value, "discriminator")) {
                            return { success: false, reason: `[#/components/schemas/TagKindDynamicString/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                          }
                          const parsed_discriminator = ((): ParserResult<KindDynamicString> => {
                            return ((value: unknown): ParserResult<KindDynamicString> => {
                              return ((value: unknown): ParserResult<"dynamicString"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/KindDynamicString]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "dynamicString":
                                    return { success: true, value: "dynamicString" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/KindDynamicString]: '${value}' expected to be enum, one of 'dynamicString'.` };
                                }
                              })(value);
                            })(value["discriminator"]);
                          })();
                          if (!parsed_discriminator.success) {
                            return { success: false, reason: parsed_discriminator.reason };
                          }
                          if (!hasProp(value, "id")) {
                            return { success: false, reason: `[#/components/schemas/TagKindDynamicString/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                          }
                          const parsed_id = ((): ParserResult<bigint> => {
                            return ((value: unknown): ParserResult<bigint> => {
                              if (typeof value === "number") {
                                return { success: true, value: BigInt(value) };
                              }
                              if (typeof value === "bigint") {
                                return { success: true, value: value };
                              }
                              return { success: false, reason: `[#/components/schemas/TagKindDynamicString/id]: '${value}' expected to be of type bigint or number.` };
                            })(value["id"]);
                          })();
                          if (!parsed_id.success) {
                            return { success: false, reason: parsed_id.reason };
                          }
                          if (!hasProp(value, "kind")) {
                            return { success: false, reason: `[#/components/schemas/TagKindDynamicString/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                          }
                          const parsed_kind = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/TagKindDynamicString/kind]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["kind"]);
                          })();
                          if (!parsed_kind.success) {
                            return { success: false, reason: parsed_kind.reason };
                          }
                          return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                        })(value);
                      })(value["tagKind"]);
                    })();
                    if (!parsed_tagKind.success) {
                      return { success: false, reason: parsed_tagKind.reason };
                    }
                    if (!hasProp(value, "value")) {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicString/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                    }
                    const parsed_value = ((): ParserResult<string> => {
                      return ((value: unknown): ParserResult<string> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/Tag/dynamicString/value]: '${value}' expected to be of type string.` };
                        }
                        return { success: true, value: value };
                      })(value["value"]);
                    })();
                    if (!parsed_value.success) {
                      return { success: false, reason: parsed_value.reason };
                    }
                    return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                  })(value);
                  if (!parsedVariant.success) {
                    return { success: false, reason: parsedVariant.reason };
                  }
                  return { success: true, value: { discriminator: "dynamicString" as const, ...parsedVariant.value } };
                }
                case "dynamicBoolean": {
                  const parsedVariant = ((
                    value: unknown,
                  ): ParserResult<{
                    exclude: boolean;
                    score: number;
                    source: TagSourceType;
                    tagKind: TagKindDynamicBoolean;
                    value: boolean;
                  }> => {
                    if (typeof value !== "object") {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean]: '${value}' expected to be of type 'object'.` };
                    }
                    if (value === null) {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean]: '${value}' expected to not be null.` };
                    }
                    if (!hasProp(value, "exclude")) {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                    }
                    const parsed_exclude = ((): ParserResult<boolean> => {
                      return ((value: unknown): ParserResult<boolean> => {
                        if (typeof value !== "boolean") {
                          return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/exclude]: '${value}' expected to be of type boolean.` };
                        }
                        return { success: true, value: value };
                      })(value["exclude"]);
                    })();
                    if (!parsed_exclude.success) {
                      return { success: false, reason: parsed_exclude.reason };
                    }
                    if (!hasProp(value, "score")) {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                    }
                    const parsed_score = ((): ParserResult<number> => {
                      return ((value: unknown): ParserResult<number> => {
                        if (typeof value === "number") {
                          return { success: true, value: value };
                        }
                        if (typeof value === "bigint") {
                          return { success: true, value: Number(value) };
                        }
                        return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/score]: '${value}' expected to be of type number or bigint.` };
                      })(value["score"]);
                    })();
                    if (!parsed_score.success) {
                      return { success: false, reason: parsed_score.reason };
                    }
                    if (!hasProp(value, "source")) {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                    }
                    const parsed_source = ((): ParserResult<TagSourceType> => {
                      return ((value: unknown): ParserResult<TagSourceType> => {
                        return ((value: unknown): ParserResult<"USER" | "AI"> => {
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                          }
                          switch (value) {
                            case "USER":
                              return { success: true, value: "USER" };
                            case "AI":
                              return { success: true, value: "AI" };
                            default:
                              return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                          }
                        })(value);
                      })(value["source"]);
                    })();
                    if (!parsed_source.success) {
                      return { success: false, reason: parsed_source.reason };
                    }
                    if (!hasProp(value, "tagKind")) {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                    }
                    const parsed_tagKind = ((): ParserResult<TagKindDynamicBoolean> => {
                      return ((value: unknown): ParserResult<TagKindDynamicBoolean> => {
                        return ((
                          value: unknown,
                        ): ParserResult<{
                          discriminator: KindDynamicBoolean;
                          id: bigint;
                          kind: string;
                        }> => {
                          if (typeof value !== "object") {
                            return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean]: '${value}' expected to be of type 'object'.` };
                          }
                          if (value === null) {
                            return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean]: '${value}' expected to not be null.` };
                          }
                          if (!hasProp(value, "discriminator")) {
                            return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                          }
                          const parsed_discriminator = ((): ParserResult<KindDynamicBoolean> => {
                            return ((value: unknown): ParserResult<KindDynamicBoolean> => {
                              return ((value: unknown): ParserResult<"dynamicBoolean"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/KindDynamicBoolean]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "dynamicBoolean":
                                    return { success: true, value: "dynamicBoolean" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/KindDynamicBoolean]: '${value}' expected to be enum, one of 'dynamicBoolean'.` };
                                }
                              })(value);
                            })(value["discriminator"]);
                          })();
                          if (!parsed_discriminator.success) {
                            return { success: false, reason: parsed_discriminator.reason };
                          }
                          if (!hasProp(value, "id")) {
                            return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                          }
                          const parsed_id = ((): ParserResult<bigint> => {
                            return ((value: unknown): ParserResult<bigint> => {
                              if (typeof value === "number") {
                                return { success: true, value: BigInt(value) };
                              }
                              if (typeof value === "bigint") {
                                return { success: true, value: value };
                              }
                              return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/id]: '${value}' expected to be of type bigint or number.` };
                            })(value["id"]);
                          })();
                          if (!parsed_id.success) {
                            return { success: false, reason: parsed_id.reason };
                          }
                          if (!hasProp(value, "kind")) {
                            return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                          }
                          const parsed_kind = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/kind]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["kind"]);
                          })();
                          if (!parsed_kind.success) {
                            return { success: false, reason: parsed_kind.reason };
                          }
                          return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                        })(value);
                      })(value["tagKind"]);
                    })();
                    if (!parsed_tagKind.success) {
                      return { success: false, reason: parsed_tagKind.reason };
                    }
                    if (!hasProp(value, "value")) {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                    }
                    const parsed_value = ((): ParserResult<boolean> => {
                      return ((value: unknown): ParserResult<boolean> => {
                        if (typeof value !== "boolean") {
                          return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/value]: '${value}' expected to be of type boolean.` };
                        }
                        return { success: true, value: value };
                      })(value["value"]);
                    })();
                    if (!parsed_value.success) {
                      return { success: false, reason: parsed_value.reason };
                    }
                    return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                  })(value);
                  if (!parsedVariant.success) {
                    return { success: false, reason: parsedVariant.reason };
                  }
                  return { success: true, value: { discriminator: "dynamicBoolean" as const, ...parsedVariant.value } };
                }
                case "dynamicNumber": {
                  const parsedVariant = ((
                    value: unknown,
                  ): ParserResult<{
                    exclude: boolean;
                    score: number;
                    source: TagSourceType;
                    tagKind: TagKindDynamicNumber;
                    value: number;
                  }> => {
                    if (typeof value !== "object") {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber]: '${value}' expected to be of type 'object'.` };
                    }
                    if (value === null) {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber]: '${value}' expected to not be null.` };
                    }
                    if (!hasProp(value, "exclude")) {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                    }
                    const parsed_exclude = ((): ParserResult<boolean> => {
                      return ((value: unknown): ParserResult<boolean> => {
                        if (typeof value !== "boolean") {
                          return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/exclude]: '${value}' expected to be of type boolean.` };
                        }
                        return { success: true, value: value };
                      })(value["exclude"]);
                    })();
                    if (!parsed_exclude.success) {
                      return { success: false, reason: parsed_exclude.reason };
                    }
                    if (!hasProp(value, "score")) {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                    }
                    const parsed_score = ((): ParserResult<number> => {
                      return ((value: unknown): ParserResult<number> => {
                        if (typeof value === "number") {
                          return { success: true, value: value };
                        }
                        if (typeof value === "bigint") {
                          return { success: true, value: Number(value) };
                        }
                        return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/score]: '${value}' expected to be of type number or bigint.` };
                      })(value["score"]);
                    })();
                    if (!parsed_score.success) {
                      return { success: false, reason: parsed_score.reason };
                    }
                    if (!hasProp(value, "source")) {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                    }
                    const parsed_source = ((): ParserResult<TagSourceType> => {
                      return ((value: unknown): ParserResult<TagSourceType> => {
                        return ((value: unknown): ParserResult<"USER" | "AI"> => {
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                          }
                          switch (value) {
                            case "USER":
                              return { success: true, value: "USER" };
                            case "AI":
                              return { success: true, value: "AI" };
                            default:
                              return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                          }
                        })(value);
                      })(value["source"]);
                    })();
                    if (!parsed_source.success) {
                      return { success: false, reason: parsed_source.reason };
                    }
                    if (!hasProp(value, "tagKind")) {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                    }
                    const parsed_tagKind = ((): ParserResult<TagKindDynamicNumber> => {
                      return ((value: unknown): ParserResult<TagKindDynamicNumber> => {
                        return ((
                          value: unknown,
                        ): ParserResult<{
                          discriminator: KindDynamicNumber;
                          id: bigint;
                          kind: string;
                        }> => {
                          if (typeof value !== "object") {
                            return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber]: '${value}' expected to be of type 'object'.` };
                          }
                          if (value === null) {
                            return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber]: '${value}' expected to not be null.` };
                          }
                          if (!hasProp(value, "discriminator")) {
                            return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                          }
                          const parsed_discriminator = ((): ParserResult<KindDynamicNumber> => {
                            return ((value: unknown): ParserResult<KindDynamicNumber> => {
                              return ((value: unknown): ParserResult<"dynamicNumber"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/KindDynamicNumber]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "dynamicNumber":
                                    return { success: true, value: "dynamicNumber" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/KindDynamicNumber]: '${value}' expected to be enum, one of 'dynamicNumber'.` };
                                }
                              })(value);
                            })(value["discriminator"]);
                          })();
                          if (!parsed_discriminator.success) {
                            return { success: false, reason: parsed_discriminator.reason };
                          }
                          if (!hasProp(value, "id")) {
                            return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                          }
                          const parsed_id = ((): ParserResult<bigint> => {
                            return ((value: unknown): ParserResult<bigint> => {
                              if (typeof value === "number") {
                                return { success: true, value: BigInt(value) };
                              }
                              if (typeof value === "bigint") {
                                return { success: true, value: value };
                              }
                              return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber/id]: '${value}' expected to be of type bigint or number.` };
                            })(value["id"]);
                          })();
                          if (!parsed_id.success) {
                            return { success: false, reason: parsed_id.reason };
                          }
                          if (!hasProp(value, "kind")) {
                            return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                          }
                          const parsed_kind = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber/kind]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["kind"]);
                          })();
                          if (!parsed_kind.success) {
                            return { success: false, reason: parsed_kind.reason };
                          }
                          return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                        })(value);
                      })(value["tagKind"]);
                    })();
                    if (!parsed_tagKind.success) {
                      return { success: false, reason: parsed_tagKind.reason };
                    }
                    if (!hasProp(value, "value")) {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                    }
                    const parsed_value = ((): ParserResult<number> => {
                      return ((value: unknown): ParserResult<number> => {
                        if (typeof value === "number") {
                          return { success: true, value: value };
                        }
                        return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/value]: '${value}' expected to be of type number.` };
                      })(value["value"]);
                    })();
                    if (!parsed_value.success) {
                      return { success: false, reason: parsed_value.reason };
                    }
                    return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                  })(value);
                  if (!parsedVariant.success) {
                    return { success: false, reason: parsedVariant.reason };
                  }
                  return { success: true, value: { discriminator: "dynamicNumber" as const, ...parsedVariant.value } };
                }
                case "dynamicVoid": {
                  const parsedVariant = ((
                    value: unknown,
                  ): ParserResult<{
                    exclude: boolean;
                    score: number;
                    source: TagSourceType;
                    tagKind: TagKindDynamicVoid;
                  }> => {
                    if (typeof value !== "object") {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid]: '${value}' expected to be of type 'object'.` };
                    }
                    if (value === null) {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid]: '${value}' expected to not be null.` };
                    }
                    if (!hasProp(value, "exclude")) {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                    }
                    const parsed_exclude = ((): ParserResult<boolean> => {
                      return ((value: unknown): ParserResult<boolean> => {
                        if (typeof value !== "boolean") {
                          return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/exclude]: '${value}' expected to be of type boolean.` };
                        }
                        return { success: true, value: value };
                      })(value["exclude"]);
                    })();
                    if (!parsed_exclude.success) {
                      return { success: false, reason: parsed_exclude.reason };
                    }
                    if (!hasProp(value, "score")) {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                    }
                    const parsed_score = ((): ParserResult<number> => {
                      return ((value: unknown): ParserResult<number> => {
                        if (typeof value === "number") {
                          return { success: true, value: value };
                        }
                        if (typeof value === "bigint") {
                          return { success: true, value: Number(value) };
                        }
                        return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/score]: '${value}' expected to be of type number or bigint.` };
                      })(value["score"]);
                    })();
                    if (!parsed_score.success) {
                      return { success: false, reason: parsed_score.reason };
                    }
                    if (!hasProp(value, "source")) {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                    }
                    const parsed_source = ((): ParserResult<TagSourceType> => {
                      return ((value: unknown): ParserResult<TagSourceType> => {
                        return ((value: unknown): ParserResult<"USER" | "AI"> => {
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                          }
                          switch (value) {
                            case "USER":
                              return { success: true, value: "USER" };
                            case "AI":
                              return { success: true, value: "AI" };
                            default:
                              return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                          }
                        })(value);
                      })(value["source"]);
                    })();
                    if (!parsed_source.success) {
                      return { success: false, reason: parsed_source.reason };
                    }
                    if (!hasProp(value, "tagKind")) {
                      return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                    }
                    const parsed_tagKind = ((): ParserResult<TagKindDynamicVoid> => {
                      return ((value: unknown): ParserResult<TagKindDynamicVoid> => {
                        return ((
                          value: unknown,
                        ): ParserResult<{
                          discriminator: KindDynamicVoid;
                          id: bigint;
                          kind: string;
                        }> => {
                          if (typeof value !== "object") {
                            return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid]: '${value}' expected to be of type 'object'.` };
                          }
                          if (value === null) {
                            return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid]: '${value}' expected to not be null.` };
                          }
                          if (!hasProp(value, "discriminator")) {
                            return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                          }
                          const parsed_discriminator = ((): ParserResult<KindDynamicVoid> => {
                            return ((value: unknown): ParserResult<KindDynamicVoid> => {
                              return ((value: unknown): ParserResult<"dynamicVoid"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/KindDynamicVoid]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "dynamicVoid":
                                    return { success: true, value: "dynamicVoid" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/KindDynamicVoid]: '${value}' expected to be enum, one of 'dynamicVoid'.` };
                                }
                              })(value);
                            })(value["discriminator"]);
                          })();
                          if (!parsed_discriminator.success) {
                            return { success: false, reason: parsed_discriminator.reason };
                          }
                          if (!hasProp(value, "id")) {
                            return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                          }
                          const parsed_id = ((): ParserResult<bigint> => {
                            return ((value: unknown): ParserResult<bigint> => {
                              if (typeof value === "number") {
                                return { success: true, value: BigInt(value) };
                              }
                              if (typeof value === "bigint") {
                                return { success: true, value: value };
                              }
                              return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid/id]: '${value}' expected to be of type bigint or number.` };
                            })(value["id"]);
                          })();
                          if (!parsed_id.success) {
                            return { success: false, reason: parsed_id.reason };
                          }
                          if (!hasProp(value, "kind")) {
                            return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                          }
                          const parsed_kind = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid/kind]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["kind"]);
                          })();
                          if (!parsed_kind.success) {
                            return { success: false, reason: parsed_kind.reason };
                          }
                          return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                        })(value);
                      })(value["tagKind"]);
                    })();
                    if (!parsed_tagKind.success) {
                      return { success: false, reason: parsed_tagKind.reason };
                    }
                    return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value } };
                  })(value);
                  if (!parsedVariant.success) {
                    return { success: false, reason: parsedVariant.reason };
                  }
                  return { success: true, value: { discriminator: "dynamicVoid" as const, ...parsedVariant.value } };
                }
                case "channel": {
                  const parsedVariant = ((
                    value: unknown,
                  ): ParserResult<{
                    exclude: boolean;
                    score: number;
                    source: TagSourceType;
                    tagKind: TagKindChannel;
                    value: string;
                  }> => {
                    if (typeof value !== "object") {
                      return { success: false, reason: `[#/components/schemas/Tag/channel]: '${value}' expected to be of type 'object'.` };
                    }
                    if (value === null) {
                      return { success: false, reason: `[#/components/schemas/Tag/channel]: '${value}' expected to not be null.` };
                    }
                    if (!hasProp(value, "exclude")) {
                      return { success: false, reason: `[#/components/schemas/Tag/channel/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                    }
                    const parsed_exclude = ((): ParserResult<boolean> => {
                      return ((value: unknown): ParserResult<boolean> => {
                        if (typeof value !== "boolean") {
                          return { success: false, reason: `[#/components/schemas/Tag/channel/exclude]: '${value}' expected to be of type boolean.` };
                        }
                        return { success: true, value: value };
                      })(value["exclude"]);
                    })();
                    if (!parsed_exclude.success) {
                      return { success: false, reason: parsed_exclude.reason };
                    }
                    if (!hasProp(value, "score")) {
                      return { success: false, reason: `[#/components/schemas/Tag/channel/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                    }
                    const parsed_score = ((): ParserResult<number> => {
                      return ((value: unknown): ParserResult<number> => {
                        if (typeof value === "number") {
                          return { success: true, value: value };
                        }
                        if (typeof value === "bigint") {
                          return { success: true, value: Number(value) };
                        }
                        return { success: false, reason: `[#/components/schemas/Tag/channel/score]: '${value}' expected to be of type number or bigint.` };
                      })(value["score"]);
                    })();
                    if (!parsed_score.success) {
                      return { success: false, reason: parsed_score.reason };
                    }
                    if (!hasProp(value, "source")) {
                      return { success: false, reason: `[#/components/schemas/Tag/channel/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                    }
                    const parsed_source = ((): ParserResult<TagSourceType> => {
                      return ((value: unknown): ParserResult<TagSourceType> => {
                        return ((value: unknown): ParserResult<"USER" | "AI"> => {
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                          }
                          switch (value) {
                            case "USER":
                              return { success: true, value: "USER" };
                            case "AI":
                              return { success: true, value: "AI" };
                            default:
                              return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                          }
                        })(value);
                      })(value["source"]);
                    })();
                    if (!parsed_source.success) {
                      return { success: false, reason: parsed_source.reason };
                    }
                    if (!hasProp(value, "tagKind")) {
                      return { success: false, reason: `[#/components/schemas/Tag/channel/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                    }
                    const parsed_tagKind = ((): ParserResult<TagKindChannel> => {
                      return ((value: unknown): ParserResult<TagKindChannel> => {
                        return ((
                          value: unknown,
                        ): ParserResult<{
                          discriminator: KindChannel;
                          id: bigint;
                          kind: KindChannel;
                        }> => {
                          if (typeof value !== "object") {
                            return { success: false, reason: `[#/components/schemas/TagKindChannel]: '${value}' expected to be of type 'object'.` };
                          }
                          if (value === null) {
                            return { success: false, reason: `[#/components/schemas/TagKindChannel]: '${value}' expected to not be null.` };
                          }
                          if (!hasProp(value, "discriminator")) {
                            return { success: false, reason: `[#/components/schemas/TagKindChannel/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                          }
                          const parsed_discriminator = ((): ParserResult<KindChannel> => {
                            return ((value: unknown): ParserResult<KindChannel> => {
                              return ((value: unknown): ParserResult<"channel"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/KindChannel]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "channel":
                                    return { success: true, value: "channel" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/KindChannel]: '${value}' expected to be enum, one of 'channel'.` };
                                }
                              })(value);
                            })(value["discriminator"]);
                          })();
                          if (!parsed_discriminator.success) {
                            return { success: false, reason: parsed_discriminator.reason };
                          }
                          if (!hasProp(value, "id")) {
                            return { success: false, reason: `[#/components/schemas/TagKindChannel/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                          }
                          const parsed_id = ((): ParserResult<bigint> => {
                            return ((value: unknown): ParserResult<bigint> => {
                              if (typeof value === "number") {
                                return { success: true, value: BigInt(value) };
                              }
                              if (typeof value === "bigint") {
                                return { success: true, value: value };
                              }
                              return { success: false, reason: `[#/components/schemas/TagKindChannel/id]: '${value}' expected to be of type bigint or number.` };
                            })(value["id"]);
                          })();
                          if (!parsed_id.success) {
                            return { success: false, reason: parsed_id.reason };
                          }
                          if (!hasProp(value, "kind")) {
                            return { success: false, reason: `[#/components/schemas/TagKindChannel/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                          }
                          const parsed_kind = ((): ParserResult<KindChannel> => {
                            return ((value: unknown): ParserResult<KindChannel> => {
                              return ((value: unknown): ParserResult<"channel"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/KindChannel]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "channel":
                                    return { success: true, value: "channel" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/KindChannel]: '${value}' expected to be enum, one of 'channel'.` };
                                }
                              })(value);
                            })(value["kind"]);
                          })();
                          if (!parsed_kind.success) {
                            return { success: false, reason: parsed_kind.reason };
                          }
                          return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                        })(value);
                      })(value["tagKind"]);
                    })();
                    if (!parsed_tagKind.success) {
                      return { success: false, reason: parsed_tagKind.reason };
                    }
                    if (!hasProp(value, "value")) {
                      return { success: false, reason: `[#/components/schemas/Tag/channel/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                    }
                    const parsed_value = ((): ParserResult<string> => {
                      return ((value: unknown): ParserResult<string> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/Tag/channel/value]: '${value}' expected to be of type string.` };
                        }
                        return { success: true, value: value };
                      })(value["value"]);
                    })();
                    if (!parsed_value.success) {
                      return { success: false, reason: parsed_value.reason };
                    }
                    return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                  })(value);
                  if (!parsedVariant.success) {
                    return { success: false, reason: parsedVariant.reason };
                  }
                  return { success: true, value: { discriminator: "channel" as const, ...parsedVariant.value } };
                }
                case "primary-skill": {
                  const parsedVariant = ((
                    value: unknown,
                  ): ParserResult<{
                    exclude: boolean;
                    score: number;
                    source: TagSourceType;
                    tagKind: TagKindPrimarySkill;
                    value: string;
                  }> => {
                    if (typeof value !== "object") {
                      return { success: false, reason: `[#/components/schemas/Tag/primary-skill]: '${value}' expected to be of type 'object'.` };
                    }
                    if (value === null) {
                      return { success: false, reason: `[#/components/schemas/Tag/primary-skill]: '${value}' expected to not be null.` };
                    }
                    if (!hasProp(value, "exclude")) {
                      return { success: false, reason: `[#/components/schemas/Tag/primary-skill/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                    }
                    const parsed_exclude = ((): ParserResult<boolean> => {
                      return ((value: unknown): ParserResult<boolean> => {
                        if (typeof value !== "boolean") {
                          return { success: false, reason: `[#/components/schemas/Tag/primary-skill/exclude]: '${value}' expected to be of type boolean.` };
                        }
                        return { success: true, value: value };
                      })(value["exclude"]);
                    })();
                    if (!parsed_exclude.success) {
                      return { success: false, reason: parsed_exclude.reason };
                    }
                    if (!hasProp(value, "score")) {
                      return { success: false, reason: `[#/components/schemas/Tag/primary-skill/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                    }
                    const parsed_score = ((): ParserResult<number> => {
                      return ((value: unknown): ParserResult<number> => {
                        if (typeof value === "number") {
                          return { success: true, value: value };
                        }
                        if (typeof value === "bigint") {
                          return { success: true, value: Number(value) };
                        }
                        return { success: false, reason: `[#/components/schemas/Tag/primary-skill/score]: '${value}' expected to be of type number or bigint.` };
                      })(value["score"]);
                    })();
                    if (!parsed_score.success) {
                      return { success: false, reason: parsed_score.reason };
                    }
                    if (!hasProp(value, "source")) {
                      return { success: false, reason: `[#/components/schemas/Tag/primary-skill/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                    }
                    const parsed_source = ((): ParserResult<TagSourceType> => {
                      return ((value: unknown): ParserResult<TagSourceType> => {
                        return ((value: unknown): ParserResult<"USER" | "AI"> => {
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                          }
                          switch (value) {
                            case "USER":
                              return { success: true, value: "USER" };
                            case "AI":
                              return { success: true, value: "AI" };
                            default:
                              return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                          }
                        })(value);
                      })(value["source"]);
                    })();
                    if (!parsed_source.success) {
                      return { success: false, reason: parsed_source.reason };
                    }
                    if (!hasProp(value, "tagKind")) {
                      return { success: false, reason: `[#/components/schemas/Tag/primary-skill/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                    }
                    const parsed_tagKind = ((): ParserResult<TagKindPrimarySkill> => {
                      return ((value: unknown): ParserResult<TagKindPrimarySkill> => {
                        return ((
                          value: unknown,
                        ): ParserResult<{
                          discriminator: KindPrimarySkill;
                          id: bigint;
                          kind: KindPrimarySkill;
                        }> => {
                          if (typeof value !== "object") {
                            return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill]: '${value}' expected to be of type 'object'.` };
                          }
                          if (value === null) {
                            return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill]: '${value}' expected to not be null.` };
                          }
                          if (!hasProp(value, "discriminator")) {
                            return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                          }
                          const parsed_discriminator = ((): ParserResult<KindPrimarySkill> => {
                            return ((value: unknown): ParserResult<KindPrimarySkill> => {
                              return ((value: unknown): ParserResult<"primary-skill"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/KindPrimarySkill]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "primary-skill":
                                    return { success: true, value: "primary-skill" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/KindPrimarySkill]: '${value}' expected to be enum, one of 'primary-skill'.` };
                                }
                              })(value);
                            })(value["discriminator"]);
                          })();
                          if (!parsed_discriminator.success) {
                            return { success: false, reason: parsed_discriminator.reason };
                          }
                          if (!hasProp(value, "id")) {
                            return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                          }
                          const parsed_id = ((): ParserResult<bigint> => {
                            return ((value: unknown): ParserResult<bigint> => {
                              if (typeof value === "number") {
                                return { success: true, value: BigInt(value) };
                              }
                              if (typeof value === "bigint") {
                                return { success: true, value: value };
                              }
                              return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill/id]: '${value}' expected to be of type bigint or number.` };
                            })(value["id"]);
                          })();
                          if (!parsed_id.success) {
                            return { success: false, reason: parsed_id.reason };
                          }
                          if (!hasProp(value, "kind")) {
                            return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                          }
                          const parsed_kind = ((): ParserResult<KindPrimarySkill> => {
                            return ((value: unknown): ParserResult<KindPrimarySkill> => {
                              return ((value: unknown): ParserResult<"primary-skill"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/KindPrimarySkill]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "primary-skill":
                                    return { success: true, value: "primary-skill" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/KindPrimarySkill]: '${value}' expected to be enum, one of 'primary-skill'.` };
                                }
                              })(value);
                            })(value["kind"]);
                          })();
                          if (!parsed_kind.success) {
                            return { success: false, reason: parsed_kind.reason };
                          }
                          return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                        })(value);
                      })(value["tagKind"]);
                    })();
                    if (!parsed_tagKind.success) {
                      return { success: false, reason: parsed_tagKind.reason };
                    }
                    if (!hasProp(value, "value")) {
                      return { success: false, reason: `[#/components/schemas/Tag/primary-skill/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                    }
                    const parsed_value = ((): ParserResult<string> => {
                      return ((value: unknown): ParserResult<string> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/Tag/primary-skill/value]: '${value}' expected to be of type string.` };
                        }
                        return { success: true, value: value };
                      })(value["value"]);
                    })();
                    if (!parsed_value.success) {
                      return { success: false, reason: parsed_value.reason };
                    }
                    return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                  })(value);
                  if (!parsedVariant.success) {
                    return { success: false, reason: parsedVariant.reason };
                  }
                  return { success: true, value: { discriminator: "primary-skill" as const, ...parsedVariant.value } };
                }
                case "skill": {
                  const parsedVariant = ((
                    value: unknown,
                  ): ParserResult<{
                    exclude: boolean;
                    score: number;
                    source: TagSourceType;
                    tagKind: TagKindSkill;
                    value: string;
                  }> => {
                    if (typeof value !== "object") {
                      return { success: false, reason: `[#/components/schemas/Tag/skill]: '${value}' expected to be of type 'object'.` };
                    }
                    if (value === null) {
                      return { success: false, reason: `[#/components/schemas/Tag/skill]: '${value}' expected to not be null.` };
                    }
                    if (!hasProp(value, "exclude")) {
                      return { success: false, reason: `[#/components/schemas/Tag/skill/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                    }
                    const parsed_exclude = ((): ParserResult<boolean> => {
                      return ((value: unknown): ParserResult<boolean> => {
                        if (typeof value !== "boolean") {
                          return { success: false, reason: `[#/components/schemas/Tag/skill/exclude]: '${value}' expected to be of type boolean.` };
                        }
                        return { success: true, value: value };
                      })(value["exclude"]);
                    })();
                    if (!parsed_exclude.success) {
                      return { success: false, reason: parsed_exclude.reason };
                    }
                    if (!hasProp(value, "score")) {
                      return { success: false, reason: `[#/components/schemas/Tag/skill/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                    }
                    const parsed_score = ((): ParserResult<number> => {
                      return ((value: unknown): ParserResult<number> => {
                        if (typeof value === "number") {
                          return { success: true, value: value };
                        }
                        if (typeof value === "bigint") {
                          return { success: true, value: Number(value) };
                        }
                        return { success: false, reason: `[#/components/schemas/Tag/skill/score]: '${value}' expected to be of type number or bigint.` };
                      })(value["score"]);
                    })();
                    if (!parsed_score.success) {
                      return { success: false, reason: parsed_score.reason };
                    }
                    if (!hasProp(value, "source")) {
                      return { success: false, reason: `[#/components/schemas/Tag/skill/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                    }
                    const parsed_source = ((): ParserResult<TagSourceType> => {
                      return ((value: unknown): ParserResult<TagSourceType> => {
                        return ((value: unknown): ParserResult<"USER" | "AI"> => {
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                          }
                          switch (value) {
                            case "USER":
                              return { success: true, value: "USER" };
                            case "AI":
                              return { success: true, value: "AI" };
                            default:
                              return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                          }
                        })(value);
                      })(value["source"]);
                    })();
                    if (!parsed_source.success) {
                      return { success: false, reason: parsed_source.reason };
                    }
                    if (!hasProp(value, "tagKind")) {
                      return { success: false, reason: `[#/components/schemas/Tag/skill/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                    }
                    const parsed_tagKind = ((): ParserResult<TagKindSkill> => {
                      return ((value: unknown): ParserResult<TagKindSkill> => {
                        return ((
                          value: unknown,
                        ): ParserResult<{
                          discriminator: KindSkill;
                          id: bigint;
                          kind: KindSkill;
                        }> => {
                          if (typeof value !== "object") {
                            return { success: false, reason: `[#/components/schemas/TagKindSkill]: '${value}' expected to be of type 'object'.` };
                          }
                          if (value === null) {
                            return { success: false, reason: `[#/components/schemas/TagKindSkill]: '${value}' expected to not be null.` };
                          }
                          if (!hasProp(value, "discriminator")) {
                            return { success: false, reason: `[#/components/schemas/TagKindSkill/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                          }
                          const parsed_discriminator = ((): ParserResult<KindSkill> => {
                            return ((value: unknown): ParserResult<KindSkill> => {
                              return ((value: unknown): ParserResult<"skill"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/KindSkill]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "skill":
                                    return { success: true, value: "skill" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/KindSkill]: '${value}' expected to be enum, one of 'skill'.` };
                                }
                              })(value);
                            })(value["discriminator"]);
                          })();
                          if (!parsed_discriminator.success) {
                            return { success: false, reason: parsed_discriminator.reason };
                          }
                          if (!hasProp(value, "id")) {
                            return { success: false, reason: `[#/components/schemas/TagKindSkill/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                          }
                          const parsed_id = ((): ParserResult<bigint> => {
                            return ((value: unknown): ParserResult<bigint> => {
                              if (typeof value === "number") {
                                return { success: true, value: BigInt(value) };
                              }
                              if (typeof value === "bigint") {
                                return { success: true, value: value };
                              }
                              return { success: false, reason: `[#/components/schemas/TagKindSkill/id]: '${value}' expected to be of type bigint or number.` };
                            })(value["id"]);
                          })();
                          if (!parsed_id.success) {
                            return { success: false, reason: parsed_id.reason };
                          }
                          if (!hasProp(value, "kind")) {
                            return { success: false, reason: `[#/components/schemas/TagKindSkill/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                          }
                          const parsed_kind = ((): ParserResult<KindSkill> => {
                            return ((value: unknown): ParserResult<KindSkill> => {
                              return ((value: unknown): ParserResult<"skill"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/KindSkill]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "skill":
                                    return { success: true, value: "skill" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/KindSkill]: '${value}' expected to be enum, one of 'skill'.` };
                                }
                              })(value);
                            })(value["kind"]);
                          })();
                          if (!parsed_kind.success) {
                            return { success: false, reason: parsed_kind.reason };
                          }
                          return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                        })(value);
                      })(value["tagKind"]);
                    })();
                    if (!parsed_tagKind.success) {
                      return { success: false, reason: parsed_tagKind.reason };
                    }
                    if (!hasProp(value, "value")) {
                      return { success: false, reason: `[#/components/schemas/Tag/skill/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                    }
                    const parsed_value = ((): ParserResult<string> => {
                      return ((value: unknown): ParserResult<string> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/Tag/skill/value]: '${value}' expected to be of type string.` };
                        }
                        return { success: true, value: value };
                      })(value["value"]);
                    })();
                    if (!parsed_value.success) {
                      return { success: false, reason: parsed_value.reason };
                    }
                    return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                  })(value);
                  if (!parsedVariant.success) {
                    return { success: false, reason: parsedVariant.reason };
                  }
                  return { success: true, value: { discriminator: "skill" as const, ...parsedVariant.value } };
                }
                case "key-quality": {
                  const parsedVariant = ((
                    value: unknown,
                  ): ParserResult<{
                    exclude: boolean;
                    score: number;
                    source: TagSourceType;
                    tagKind: TagKindKeyQuality;
                    value: string;
                  }> => {
                    if (typeof value !== "object") {
                      return { success: false, reason: `[#/components/schemas/Tag/key-quality]: '${value}' expected to be of type 'object'.` };
                    }
                    if (value === null) {
                      return { success: false, reason: `[#/components/schemas/Tag/key-quality]: '${value}' expected to not be null.` };
                    }
                    if (!hasProp(value, "exclude")) {
                      return { success: false, reason: `[#/components/schemas/Tag/key-quality/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                    }
                    const parsed_exclude = ((): ParserResult<boolean> => {
                      return ((value: unknown): ParserResult<boolean> => {
                        if (typeof value !== "boolean") {
                          return { success: false, reason: `[#/components/schemas/Tag/key-quality/exclude]: '${value}' expected to be of type boolean.` };
                        }
                        return { success: true, value: value };
                      })(value["exclude"]);
                    })();
                    if (!parsed_exclude.success) {
                      return { success: false, reason: parsed_exclude.reason };
                    }
                    if (!hasProp(value, "score")) {
                      return { success: false, reason: `[#/components/schemas/Tag/key-quality/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                    }
                    const parsed_score = ((): ParserResult<number> => {
                      return ((value: unknown): ParserResult<number> => {
                        if (typeof value === "number") {
                          return { success: true, value: value };
                        }
                        if (typeof value === "bigint") {
                          return { success: true, value: Number(value) };
                        }
                        return { success: false, reason: `[#/components/schemas/Tag/key-quality/score]: '${value}' expected to be of type number or bigint.` };
                      })(value["score"]);
                    })();
                    if (!parsed_score.success) {
                      return { success: false, reason: parsed_score.reason };
                    }
                    if (!hasProp(value, "source")) {
                      return { success: false, reason: `[#/components/schemas/Tag/key-quality/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                    }
                    const parsed_source = ((): ParserResult<TagSourceType> => {
                      return ((value: unknown): ParserResult<TagSourceType> => {
                        return ((value: unknown): ParserResult<"USER" | "AI"> => {
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                          }
                          switch (value) {
                            case "USER":
                              return { success: true, value: "USER" };
                            case "AI":
                              return { success: true, value: "AI" };
                            default:
                              return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                          }
                        })(value);
                      })(value["source"]);
                    })();
                    if (!parsed_source.success) {
                      return { success: false, reason: parsed_source.reason };
                    }
                    if (!hasProp(value, "tagKind")) {
                      return { success: false, reason: `[#/components/schemas/Tag/key-quality/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                    }
                    const parsed_tagKind = ((): ParserResult<TagKindKeyQuality> => {
                      return ((value: unknown): ParserResult<TagKindKeyQuality> => {
                        return ((
                          value: unknown,
                        ): ParserResult<{
                          discriminator: KindKeyQuality;
                          id: bigint;
                          kind: KindKeyQuality;
                        }> => {
                          if (typeof value !== "object") {
                            return { success: false, reason: `[#/components/schemas/TagKindKeyQuality]: '${value}' expected to be of type 'object'.` };
                          }
                          if (value === null) {
                            return { success: false, reason: `[#/components/schemas/TagKindKeyQuality]: '${value}' expected to not be null.` };
                          }
                          if (!hasProp(value, "discriminator")) {
                            return { success: false, reason: `[#/components/schemas/TagKindKeyQuality/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                          }
                          const parsed_discriminator = ((): ParserResult<KindKeyQuality> => {
                            return ((value: unknown): ParserResult<KindKeyQuality> => {
                              return ((value: unknown): ParserResult<"key-quality"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/KindKeyQuality]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "key-quality":
                                    return { success: true, value: "key-quality" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/KindKeyQuality]: '${value}' expected to be enum, one of 'key-quality'.` };
                                }
                              })(value);
                            })(value["discriminator"]);
                          })();
                          if (!parsed_discriminator.success) {
                            return { success: false, reason: parsed_discriminator.reason };
                          }
                          if (!hasProp(value, "id")) {
                            return { success: false, reason: `[#/components/schemas/TagKindKeyQuality/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                          }
                          const parsed_id = ((): ParserResult<bigint> => {
                            return ((value: unknown): ParserResult<bigint> => {
                              if (typeof value === "number") {
                                return { success: true, value: BigInt(value) };
                              }
                              if (typeof value === "bigint") {
                                return { success: true, value: value };
                              }
                              return { success: false, reason: `[#/components/schemas/TagKindKeyQuality/id]: '${value}' expected to be of type bigint or number.` };
                            })(value["id"]);
                          })();
                          if (!parsed_id.success) {
                            return { success: false, reason: parsed_id.reason };
                          }
                          if (!hasProp(value, "kind")) {
                            return { success: false, reason: `[#/components/schemas/TagKindKeyQuality/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                          }
                          const parsed_kind = ((): ParserResult<KindKeyQuality> => {
                            return ((value: unknown): ParserResult<KindKeyQuality> => {
                              return ((value: unknown): ParserResult<"key-quality"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/KindKeyQuality]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "key-quality":
                                    return { success: true, value: "key-quality" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/KindKeyQuality]: '${value}' expected to be enum, one of 'key-quality'.` };
                                }
                              })(value);
                            })(value["kind"]);
                          })();
                          if (!parsed_kind.success) {
                            return { success: false, reason: parsed_kind.reason };
                          }
                          return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                        })(value);
                      })(value["tagKind"]);
                    })();
                    if (!parsed_tagKind.success) {
                      return { success: false, reason: parsed_tagKind.reason };
                    }
                    if (!hasProp(value, "value")) {
                      return { success: false, reason: `[#/components/schemas/Tag/key-quality/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                    }
                    const parsed_value = ((): ParserResult<string> => {
                      return ((value: unknown): ParserResult<string> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/Tag/key-quality/value]: '${value}' expected to be of type string.` };
                        }
                        return { success: true, value: value };
                      })(value["value"]);
                    })();
                    if (!parsed_value.success) {
                      return { success: false, reason: parsed_value.reason };
                    }
                    return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                  })(value);
                  if (!parsedVariant.success) {
                    return { success: false, reason: parsedVariant.reason };
                  }
                  return { success: true, value: { discriminator: "key-quality" as const, ...parsedVariant.value } };
                }
                case "classification": {
                  const parsedVariant = ((
                    value: unknown,
                  ): ParserResult<{
                    exclude: boolean;
                    score: number;
                    source: TagSourceType;
                    tagKind: TagKindClassification;
                    value: string;
                  }> => {
                    if (typeof value !== "object") {
                      return { success: false, reason: `[#/components/schemas/Tag/classification]: '${value}' expected to be of type 'object'.` };
                    }
                    if (value === null) {
                      return { success: false, reason: `[#/components/schemas/Tag/classification]: '${value}' expected to not be null.` };
                    }
                    if (!hasProp(value, "exclude")) {
                      return { success: false, reason: `[#/components/schemas/Tag/classification/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                    }
                    const parsed_exclude = ((): ParserResult<boolean> => {
                      return ((value: unknown): ParserResult<boolean> => {
                        if (typeof value !== "boolean") {
                          return { success: false, reason: `[#/components/schemas/Tag/classification/exclude]: '${value}' expected to be of type boolean.` };
                        }
                        return { success: true, value: value };
                      })(value["exclude"]);
                    })();
                    if (!parsed_exclude.success) {
                      return { success: false, reason: parsed_exclude.reason };
                    }
                    if (!hasProp(value, "score")) {
                      return { success: false, reason: `[#/components/schemas/Tag/classification/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                    }
                    const parsed_score = ((): ParserResult<number> => {
                      return ((value: unknown): ParserResult<number> => {
                        if (typeof value === "number") {
                          return { success: true, value: value };
                        }
                        if (typeof value === "bigint") {
                          return { success: true, value: Number(value) };
                        }
                        return { success: false, reason: `[#/components/schemas/Tag/classification/score]: '${value}' expected to be of type number or bigint.` };
                      })(value["score"]);
                    })();
                    if (!parsed_score.success) {
                      return { success: false, reason: parsed_score.reason };
                    }
                    if (!hasProp(value, "source")) {
                      return { success: false, reason: `[#/components/schemas/Tag/classification/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                    }
                    const parsed_source = ((): ParserResult<TagSourceType> => {
                      return ((value: unknown): ParserResult<TagSourceType> => {
                        return ((value: unknown): ParserResult<"USER" | "AI"> => {
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                          }
                          switch (value) {
                            case "USER":
                              return { success: true, value: "USER" };
                            case "AI":
                              return { success: true, value: "AI" };
                            default:
                              return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                          }
                        })(value);
                      })(value["source"]);
                    })();
                    if (!parsed_source.success) {
                      return { success: false, reason: parsed_source.reason };
                    }
                    if (!hasProp(value, "tagKind")) {
                      return { success: false, reason: `[#/components/schemas/Tag/classification/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                    }
                    const parsed_tagKind = ((): ParserResult<TagKindClassification> => {
                      return ((value: unknown): ParserResult<TagKindClassification> => {
                        return ((
                          value: unknown,
                        ): ParserResult<{
                          discriminator: KindClassification;
                          id: bigint;
                          kind: KindClassification;
                        }> => {
                          if (typeof value !== "object") {
                            return { success: false, reason: `[#/components/schemas/TagKindClassification]: '${value}' expected to be of type 'object'.` };
                          }
                          if (value === null) {
                            return { success: false, reason: `[#/components/schemas/TagKindClassification]: '${value}' expected to not be null.` };
                          }
                          if (!hasProp(value, "discriminator")) {
                            return { success: false, reason: `[#/components/schemas/TagKindClassification/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                          }
                          const parsed_discriminator = ((): ParserResult<KindClassification> => {
                            return ((value: unknown): ParserResult<KindClassification> => {
                              return ((value: unknown): ParserResult<"classification"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/KindClassification]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "classification":
                                    return { success: true, value: "classification" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/KindClassification]: '${value}' expected to be enum, one of 'classification'.` };
                                }
                              })(value);
                            })(value["discriminator"]);
                          })();
                          if (!parsed_discriminator.success) {
                            return { success: false, reason: parsed_discriminator.reason };
                          }
                          if (!hasProp(value, "id")) {
                            return { success: false, reason: `[#/components/schemas/TagKindClassification/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                          }
                          const parsed_id = ((): ParserResult<bigint> => {
                            return ((value: unknown): ParserResult<bigint> => {
                              if (typeof value === "number") {
                                return { success: true, value: BigInt(value) };
                              }
                              if (typeof value === "bigint") {
                                return { success: true, value: value };
                              }
                              return { success: false, reason: `[#/components/schemas/TagKindClassification/id]: '${value}' expected to be of type bigint or number.` };
                            })(value["id"]);
                          })();
                          if (!parsed_id.success) {
                            return { success: false, reason: parsed_id.reason };
                          }
                          if (!hasProp(value, "kind")) {
                            return { success: false, reason: `[#/components/schemas/TagKindClassification/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                          }
                          const parsed_kind = ((): ParserResult<KindClassification> => {
                            return ((value: unknown): ParserResult<KindClassification> => {
                              return ((value: unknown): ParserResult<"classification"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/KindClassification]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "classification":
                                    return { success: true, value: "classification" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/KindClassification]: '${value}' expected to be enum, one of 'classification'.` };
                                }
                              })(value);
                            })(value["kind"]);
                          })();
                          if (!parsed_kind.success) {
                            return { success: false, reason: parsed_kind.reason };
                          }
                          return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                        })(value);
                      })(value["tagKind"]);
                    })();
                    if (!parsed_tagKind.success) {
                      return { success: false, reason: parsed_tagKind.reason };
                    }
                    if (!hasProp(value, "value")) {
                      return { success: false, reason: `[#/components/schemas/Tag/classification/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                    }
                    const parsed_value = ((): ParserResult<string> => {
                      return ((value: unknown): ParserResult<string> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/Tag/classification/value]: '${value}' expected to be of type string.` };
                        }
                        return { success: true, value: value };
                      })(value["value"]);
                    })();
                    if (!parsed_value.success) {
                      return { success: false, reason: parsed_value.reason };
                    }
                    return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                  })(value);
                  if (!parsedVariant.success) {
                    return { success: false, reason: parsedVariant.reason };
                  }
                  return { success: true, value: { discriminator: "classification" as const, ...parsedVariant.value } };
                }
                default:
                  return {
                    success: false,
                    reason: `[#/components/schemas/Tag]: '${discriminator}' expected to be one of 'dynamicString, dynamicBoolean, dynamicNumber, dynamicVoid, channel, primary-skill, skill, key-quality, classification'.`,
                  };
              }
            })(value);
          })(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/ExpertVideoAdminForm/tags]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["tags"]);
    })();
    if (!parsed_tags.success) {
      return { success: false, reason: parsed_tags.reason };
    }
    if (!hasProp(value, "teaser")) {
      return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/teaser]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'teaser'.` };
    }
    const parsed_teaser = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/teaser]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["teaser"]);
    })();
    if (!parsed_teaser.success) {
      return { success: false, reason: parsed_teaser.reason };
    }
    if (!hasProp(value, "title")) {
      return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
    }
    const parsed_title = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/title]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["title"]);
    })();
    if (!parsed_title.success) {
      return { success: false, reason: parsed_title.reason };
    }
    if (!hasProp(value, "transcript")) {
      return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/transcript]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'transcript'.` };
    }
    const parsed_transcript = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/transcript]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["transcript"]);
    })();
    if (!parsed_transcript.success) {
      return { success: false, reason: parsed_transcript.reason };
    }
    if (!hasProp(value, "vimeoLink")) {
      return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/vimeoLink]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'vimeoLink'.` };
    }
    const parsed_vimeoLink = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/vimeoLink]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["vimeoLink"]);
    })();
    if (!parsed_vimeoLink.success) {
      return { success: false, reason: parsed_vimeoLink.reason };
    }
    if (!hasProp(value, "whatYouLearn")) {
      return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/whatYouLearn]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'whatYouLearn'.` };
    }
    const parsed_whatYouLearn = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/whatYouLearn]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["whatYouLearn"]);
    })();
    if (!parsed_whatYouLearn.success) {
      return { success: false, reason: parsed_whatYouLearn.reason };
    }
    if (!hasProp(value, "youtubeLink")) {
      return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/youtubeLink]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'youtubeLink'.` };
    }
    const parsed_youtubeLink = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ExpertVideoAdminForm/youtubeLink]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["youtubeLink"]);
    })();
    if (!parsed_youtubeLink.success) {
      return { success: false, reason: parsed_youtubeLink.reason };
    }
    return {
      success: true,
      value: {
        aboutTheHost: parsed_aboutTheHost.value,
        active: parsed_active.value,
        authorIds: parsed_authorIds.value,
        authorImage: parsed_authorImage.value,
        eventDateTime: parsed_eventDateTime.value,
        expertVideoId: parsed_expertVideoId.value,
        language: parsed_language.value,
        length: parsed_length.value,
        pdf: parsed_pdf.value,
        registrationLink: parsed_registrationLink.value,
        tableOfContent: parsed_tableOfContent.value,
        tags: parsed_tags.value,
        teaser: parsed_teaser.value,
        title: parsed_title.value,
        transcript: parsed_transcript.value,
        vimeoLink: parsed_vimeoLink.value,
        whatYouLearn: parsed_whatYouLearn.value,
        youtubeLink: parsed_youtubeLink.value,
      },
    };
  })(parseJsonWithNumbersAsBigint(str));
}
